export var FavoriteEntity;
(function (FavoriteEntity) {
    FavoriteEntity["Brand"] = "Brand";
    FavoriteEntity["Category"] = "Category";
    FavoriteEntity["CompetitorReseller"] = "CompetitorReseller";
    FavoriteEntity["CompetitorStore"] = "CompetitorStore";
    FavoriteEntity["Goal"] = "Goal";
    FavoriteEntity["Mapping"] = "Mapping";
    FavoriteEntity["Product"] = "Product";
    FavoriteEntity["ProductModel"] = "ProductModel";
    FavoriteEntity["Segment"] = "Segment";
    FavoriteEntity["Zoning"] = "Zoning";
})(FavoriteEntity || (FavoriteEntity = {}));
//# sourceMappingURL=favorite-entity.js.map